module.exports = __webpack_public_path__ + "fonts/5f5d1fc38657291dde2032ac42ca953b.svg";